import React from 'react';
import {
  CogsIcon,
  LogoutIcon,
  PencilIcon,
  SwitchProjectIcon,
} from '../../components/Icons';
import Avatar from '../../components/Avatar';
import DropDownMenu from '../../components/DropdownMenu';

export interface AccountManagerLayoutProps {
  children: any;
  loaded?: boolean;
  Link: any;
  user: {
    avatar: null | string;
    name: string;
  };
  logo: string;
  routes: {
    chooseProject: string;
    editProfile?: string;
    manageAccount?: string;
  };
  logoutClick: () => void;
  dropdownTeams?: any;
}

const AccountManagerLayout: React.FC<AccountManagerLayoutProps> = ({
  children,
  loaded = true,
  Link,
  user,
  logo,
  routes,
  logoutClick,
  dropdownTeams = null,
}) => {
  return (
    <div className="bg-gray-800 w-full min-h-screen">
      <div className="w-full border-b border-gray-750">
        <div className="px-14 h-20">
          <div className="max-w-5xl mx-auto flex justify-between items-center h-full">
            <Link to={routes.chooseProject}>
              <img src={logo} alt="logo" className="h-8" />
            </Link>
            <DropDownMenu
              button={<Avatar img={user.avatar} text={user.name} />}
              className="absolute -right-2.5 bg-gray-900 mt-8 rounded-lg shadow-xl w-80 text-white z-20"
            >
              {dropdownTeams}
              <div className="bg-gray-800 rounded-lg p-2">
                {routes.editProfile && (
                  <Link
                    className="p-2 mb-1 text-sm flex items-center hover:text-secondary cursor-pointer"
                    to={routes.editProfile}
                  >
                    <PencilIcon className="block w-5 h-5 mr-3" size={20} />
                    <span>Edit Profile</span>
                  </Link>
                )}
                {routes.manageAccount && (
                  <Link
                    className="p-2 mb-1 text-sm flex items-center hover:text-secondary cursor-pointer"
                    to={routes.manageAccount}
                  >
                    <CogsIcon className="block w-5 h-5 mr-3" size={20} />
                    <span>Team Settings</span>
                  </Link>
                )}
                <Link
                  className="p-2 mb-1 text-sm flex items-center hover:text-secondary cursor-pointer"
                  to={routes.chooseProject}
                >
                  <SwitchProjectIcon className="block w-5 h-5 mr-3" size={20} />
                  <span>View Projects</span>
                </Link>
                <div
                  role={'button'}
                  className="p-2 mb-1 text-sm flex items-center hover:text-secondary rounded-b cursor-pointer"
                  onClick={logoutClick}
                >
                  <LogoutIcon className="block w-5 h-5 mr-3" size={20} />
                  <span>Logout</span>
                </div>
              </div>
              <div
                className="absolute right-4 rounded-sm"
                style={{
                  top: '-1rem',
                  width: 0,
                  height: 0,
                  borderLeft: '1rem solid transparent',
                  borderRight: '1rem solid transparent',
                  borderBottom: '1rem solid #110f15',
                }}
              ></div>
            </DropDownMenu>
          </div>
        </div>
      </div>
      {loaded ? (
        children
      ) : (
        <>
          <div>Loading...</div>
        </>
      )}
      <div id="confirm-delete-popup"></div>
    </div>
  );
};

export default AccountManagerLayout;
